import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface WarningTriangleFillIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const WarningTriangleFillIcon = ({ className, ...props }: WarningTriangleFillIconProps) => (
  <svg
    className={cn("text-[#DD8F04]", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.2659 4.0155C11.0349 2.67809 12.9647 2.67809 13.7337 4.0155L21.7767 18.0028C22.5433 19.336 21.5811 20.9996 20.0433 20.9999H3.95734C2.4193 20.9999 1.4563 19.3361 2.22296 18.0028L10.2659 4.0155ZM12.512 16.4413C12.2042 16.1643 11.7296 16.1893 11.4525 16.4969L11.4427 16.5077C11.1656 16.8155 11.1906 17.2901 11.4984 17.5673C11.8062 17.8443 12.2809 17.8194 12.5579 17.5116L12.5677 17.5009C12.8445 17.193 12.8197 16.7183 12.512 16.4413ZM12.0003 8.24988C11.5861 8.24988 11.2504 8.58572 11.2503 8.99988V12.9999C11.2503 13.4141 11.5861 13.7499 12.0003 13.7499C12.4144 13.7497 12.7503 13.414 12.7503 12.9999V8.99988C12.7502 8.58583 12.4143 8.25005 12.0003 8.24988Z"
      fill="currentColor"
    />
  </svg>
);

export default WarningTriangleFillIcon;
